import type { ActionType } from '../../store/engine/constants';
import type { PublicId, ElementType } from '../../store/engine/types';


export function dec2hex(dec) {
  return dec.toString(16).padStart(2, '0');
}

export function generatePublicIdHash(len: number) {
  const arr = new Uint8Array((len || 40) / 2);
  window.crypto.getRandomValues(arr);
  return Array.from(arr, dec2hex).join('');
}
/**
 * Builds a public id for an action.
 * We use function overloading to enforce strict types:
 * - if `elementType` is 'action', take in an `actionTypes` value
 * - if `elementType` is different than action, make sure the user is not passing an `actionTypes`
 * @param elementType type of elements that can be assigned a public id
 * @param actionType only used when elementType is 'action'. provides the metadata action type
 */


export function generatePublicId(elementType: 'action', actionType: ActionType): PublicId;
export function generatePublicId(elementType: Exclude<ElementType, 'action'>): PublicId;
export function generatePublicId(elementType: ElementType, actionType?: ActionType): PublicId {
  if (elementType === 'action' && !actionType) {
    throw new Error('Cannot build public id for action without specifying an action type');
  }
  if (elementType === 'action') {
    return `action__${actionType}__${generatePublicIdHash(20)}`;
  }
  return `${elementType}__${generatePublicIdHash(20)}`;
}
